export const HEADER_REPORT_PAGE = [
  { label: 'Report Name', sort: 'documentControl', width: 180 },
  { label: 'Client Name', sort: 'clientName', width: 150 },
  { label: 'Main Location', sort: 'mainLocation', width: 150 },
  { label: 'Sub Location 1', sort: 'subLocation1', width: 150 },
  { label: 'Sub Location 2', sort: 'subLocation2', width: 150 },
  { label: 'Vertical Level', sort: 'verticalLevel', width: 150 },
  { label: 'Location', sort: 'room', width: 150 },
  { label: 'Compliance Representative', sort: 'complianceRepresentative', width: 230 },
  { label: 'Date Reported', sort: 'date', width: 200 },
  { label: 'Actions', width: 160 }
];

export const HEADER_DOCUMENT = [
  { label: 'PDF Title', sort: 'title', width: 330 },
  { label: 'Upload Date' },
  { label: 'Actions', width: 200 }
];
